import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { platform } from '@/lib/platform';

export async function hideSplash() {
  if (!platform.isNative) return;
  await SplashScreen.hide({ fadeOutDuration: 300 });
}

export async function setStatusBarForModule(hexColor: string) {
  if (!platform.isNative) return;
  await StatusBar.setBackgroundColor({ color: hexColor });
  await StatusBar.setStyle({ style: Style.Dark });
}

// capacitor.config's StatusBar background; what a route without AppLayout's module accent shows.
export const DEFAULT_STATUS_BAR_COLOR = "#1E2A3A";

/** Light bar with dark icons, for surfaces forced to the light theme (the check-in kiosk). */
export async function setStatusBarLight() {
  if (!platform.isNative) return;
  await StatusBar.setBackgroundColor({ color: "#ffffff" });
  await StatusBar.setStyle({ style: Style.Light });
}

/** Undo setStatusBarLight; AppLayout re-applies the module accent once it mounts. */
export async function restoreDefaultStatusBar() {
  await setStatusBarForModule(DEFAULT_STATUS_BAR_COLOR);
}
